import Result from "@/core/common/Result";

export enum AgendamentoStatusResponse {
  None = 0,
  Agendado = 1,
  EmConfirmacao = 2,
  Cancelado = 3
}

export type AgendamentoResponse = {
  dataAgendamento?: string;
  tipo?: number;
  agendamentosStatus: AgendamentoStatusResponse;
  id: string;
};

export type ObterAgendamentosResponse = {
  agendamentos: AgendamentoResponse[];
};

export interface IObterAgendamentosGateway {
  getAgendamentos(): Promise<Result<ObterAgendamentosResponse>>;
}

export const obterAgendamentosGatewayDI = "obterAgendamentosGatewayDI";
